module.exports = __webpack_public_path__ + "2124f7fd8bb04f7479a362a7ed230261.svg";